import { VehiclesCanHistoryMessages, TranslationVehiclesCanHistoryMessages } from "../interfaces";

export const messages: TranslationVehiclesCanHistoryMessages = {
  [VehiclesCanHistoryMessages.title]: "Histórico de veículos - CAN",
  [VehiclesCanHistoryMessages.generalHistory]: "Histórico geral",
  [VehiclesCanHistoryMessages.historyByEquipment]: "Histórico por Veículo",
  [VehiclesCanHistoryMessages.equipment]: "Veículo",
  [VehiclesCanHistoryMessages.travels]: "Quant. Viagens",
  [VehiclesCanHistoryMessages.engineRuntime]: "Tempo Motor Ligado (h:mm)",
  [VehiclesCanHistoryMessages.idleEngineHours]: "Marcha Lenta (h:mm)",
  [VehiclesCanHistoryMessages.kmTraveled]: "Total Distância Percorrida (km)",
  [VehiclesCanHistoryMessages.speedingAlerts]: "Alerta Velocidade Excedida",
  [VehiclesCanHistoryMessages.licensePlate]: "Placa",
  [VehiclesCanHistoryMessages.fuelConsumption]: "Consumo Total Combustível (L)",
  [VehiclesCanHistoryMessages.idleFuelConsumption]: "Consumo Marcha Lenta (L)",
  [VehiclesCanHistoryMessages.avgFuelConsumption]: "Consumo Médio em Movimento (km/L)",
  [VehiclesCanHistoryMessages.litersPerHour]: "Consumo por Hora Motor (L/h)",
  [VehiclesCanHistoryMessages.litersPerM3]: "Consumo por m³ (L/m³)",
  [VehiclesCanHistoryMessages.litersPerTravel]: "Consumo por Viagem (L)",
  [VehiclesCanHistoryMessages.idleLitersPerHour]: "Consumo Marcha Lenta por Hora (L/h)",
  [VehiclesCanHistoryMessages.fuelingAlerts]: "Alerta Variação Combustível (+)",
  [VehiclesCanHistoryMessages.suddenDropAlerts]: "Alerta Variação Combustível (-)",
  [VehiclesCanHistoryMessages.highTemperatureAlerts]: "Alerta Temperatura Elevada",
  [VehiclesCanHistoryMessages.vehicleType]: "Tipo de Veículo",
  [VehiclesCanHistoryMessages.vehicles]: "Quant. Veículos"
};
